import { render, staticRenderFns } from "./InfoSettingModify.vue?vue&type=template&id=2d2b6c60"
import script from "./InfoSettingModify.vue?vue&type=script&lang=js"
export * from "./InfoSettingModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports